import { Component, Input } from '@angular/core';

import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent }  from '@trivelope/triv-ui-tools-lib';



@Component({
	selector: 'label',
	templateUrl: './label.component.html',
	styles: [ `
		:host {	display: inline-block; }
	` ]
})
export class LabelComponent {


	@Input() label = "";
	@Input() info = "";


	constructor(
		public matDialog: MatDialog,
	) {}


	showInfo() {

		if( !this.info ) return;

		this.matDialog.open( InfoDialogComponent, {
			width: '350px',
			data: this.info
		});
	}

}
